import { extendTheme } from '@chakra-ui/react';

// Radiancebook EMR Brand Colors
const colors = {
  brand: {
    black: '#000000',
    darkPurple: '#291528',
    darkGray: '#3a3e3b',
    lightGray: '#f0eff4',
    purple: '#9e829c',
  },
};

const theme = extendTheme({
  colors: {
    brand: colors.brand,
  },
  fonts: {
    heading: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
    body: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
  },
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        color: 'gray.800',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '600',
        borderRadius: 'lg',
      },
      variants: {
        solid: {
          bg: 'brand.darkPurple',
          color: 'white',
          _hover: {
            bg: 'brand.darkGray',
            transform: 'translateY(-2px)',
            boxShadow: 'lg',
          },
          _active: {
            transform: 'translateY(0)',
          },
        },
        outline: {
          borderColor: 'brand.purple',
          color: 'brand.darkPurple',
          _hover: {
            bg: 'brand.lightGray',
          },
        },
        ghost: {
          color: 'brand.darkPurple',
          _hover: {
            bg: 'brand.lightGray',
          },
        },
      },
      defaultProps: {
        variant: 'solid',
      },
    },
    Card: {
      baseStyle: {
        container: {
          borderRadius: 'xl',
          boxShadow: 'sm',
          borderWidth: '1px',
          borderColor: 'gray.200',
          _hover: {
            boxShadow: 'md',
            transform: 'translateY(-2px)',
            transition: 'all 0.2s',
          },
        },
      },
    },
    Input: {
      variants: {
        outline: {
          field: {
            borderColor: 'gray.300',
            _hover: {
              borderColor: 'brand.purple',
            },
            _focus: {
              borderColor: 'brand.darkPurple',
              boxShadow: `0 0 0 1px ${colors.brand.darkPurple}`,
            },
          },
        },
      },
    },
    Table: {
      variants: {
        simple: {
          th: {
            bg: 'brand.darkPurple',
            color: 'white',
            textTransform: 'uppercase',
            fontSize: 'sm',
            fontWeight: '600',
            letterSpacing: 'wide',
          },
          td: {
            borderColor: 'gray.200',
          },
          tr: {
            _hover: {
              bg: 'brand.lightGray',
            },
          },
        },
      },
    },
  },
});

export default theme;

